export default __webpack_public_path__ + "static/media/wilson-us-open.f240d16c.jpg";